<!-- 

CONFIGURAÇÃO DE PAGAMENTOS ON LINE

-->

<script>
import { SysVars } from '../main';
import Vue from 'vue';

export default {
    props: {
        parametros: { type: Object },
    },

    components: {
    },

    data () {
        return {
            editingFormasEnvio : false,
            editingFormasEnvioObj: null,
            showConfigShippingMethods: false
        }
    },

    computed: {

    },

    filters: {

    },

    methods: {

        handleDesativar (operadora) {
            if (operadora == 'formasenvio') {
                this.parametros.rodape.habilitaFormasEnvio = false
            }
            this.$emit('saveconfig')
        },

        handleAtivar (operadora) {
            if (operadora == 'formasenvio') {
                this.editingFormasEnvio = true
                if (!this.parametros.rodape.formasenvio)
                    this.parametros.rodape.formasenvio = { correios: true, pac: true, sedex: true, }
                this.editingFormasEnvioObj = {...this.parametros.rodape.fomasenvio} 
            }
        },

        handleSalvarFormasEnvio () {
            this.parametros.rodape.habilitaFormasEnvio = true
            this.editingFormasEnvio = true
            this.$emit('saveconfig')
        },

        handleCancelarFormasEnvio () {
            this.parametros.rodape.formasenvio = this.editingFormasEnvioObj
            this.editingFormasEnvio = false
            this.$emit('saveconfig')
        },

        handleEditFormasEnvio () {
            this.editingFormasEnvioObj = {...this.parametros.rodape.formasenvio}
            this.editingFormasEnvio = true            
        }



    },

    watch: {

    },

    mounted () {

    },

    created () {
    }

}

</script>

<template>

  <div class="mb-2 mt-5 container-accordion cursor-pointer" :class="showConfigShippingMethods ? 'container-open' : 'container-close'">
    <div class="row" @click="() => showConfigShippingMethods = !showConfigShippingMethods">
        <div class="col py-2">
            <span class="lbl-deal-title mb-3">Imagens Formas de Envio</span>
            <div class="row mb-2">
                <div class="col">
                    <span>Configure as Formas de Envio exibidas no rodapé da sua loja!</span>
                </div>
            </div>
        </div>
        <button class=" col-1 border-0 bg-transparent" style="outline: none">
                <i :class="'text-secondary fa fa-chevron-' + (showConfigShippingMethods ? 'up' : 'down')"></i>
        </button>
    </div>

    <div class="border p-3 mb-2" v-show="showConfigShippingMethods">
        <!-- Formas de Envio rodape -->
        <div class="row mb-2">
            <div class="col-12">
                <span class="badge badge-success" v-if="parametros.rodape.habilitaFormasEnvio">Ativado</span>
            </div>
        </div>
        <div class="row" v-if="!parametros.rodape.habilitaFormasEnvio && !editingFormasEnvio">
            <div class="col-md-12">
                <label class="lbl-edit">                    
                Habilitar imagens das Formas de Envio no final da página
                </label>
            </div>
            <div class="col-md-12">
                <v-button label="Ativar" :success="true" @click="handleAtivar('formasenvio')"></v-button>
            </div>
        </div>
        <div class="row mt-3" v-if="parametros.rodape.habilitaFormasEnvio || editingFormasEnvio">
            <div class="col-md-12 mb-2">
                <label class="lbl-edit d-flex align-items-center" style="gap:10px">                    
                    <input 
                        type="checkbox"
                        v-model="parametros.rodape.formasenvio.correios" 
                        :disabled="!editingFormasEnvio"
                        id="correios"
                        name="correios"
                        v-show="false"
                    >
                    <div>
                        <i class="fa fa-times" :class="!editingFormasEnvio ? 'text-secondary' :'text-danger'" for="correios" v-if="!parametros.rodape.formasenvio.correios" ></i>                    
                        <i class="fa fa-check" :class="!editingFormasEnvio ? 'text-secondary' :'text-success'" for="correios" v-else></i>                    
                    </div>
                    <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formasenvio/correios.png" class="formasenvio"> Correios
                </label>
            </div>

            <div class="col-md-12 mb-2">
                <label class="lbl-edit d-flex align-items-center" style="gap:10px">                   
                    <input 
                        type="checkbox"
                        v-model="parametros.rodape.formasenvio.pac" 
                        :disabled="!editingFormasEnvio"
                        id="pac"
                        name="pac"
                        v-show="false"
                    >
                    <div>
                        <i class="fa fa-times" :class="!editingFormasEnvio ? 'text-secondary' :'text-danger'" for="pac" v-if="!parametros.rodape.formasenvio.pac" ></i>                    
                        <i class="fa fa-check" :class="!editingFormasEnvio ? 'text-secondary' :'text-success'" for="pac" v-else></i>                    
                    </div>
                    <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formasenvio/pac.png" class="formasenvio"> PAC
                </label>
            </div>

            <div class="col-md-12 mb-2">
                <label class="lbl-edit d-flex align-items-center" style="gap:10px">                   
                    <input 
                        type="checkbox" 
                        v-model="parametros.rodape.formasenvio.sedex" 
                        :disabled="!editingFormasEnvio"
                        id="sedex"
                        name="sedex"
                        v-show="false"
                    >
                    <div>
                        <i class="fa fa-times" :class="!editingFormasEnvio ? 'text-secondary' :'text-danger'" for="sedex" v-if="!parametros.rodape.formasenvio.sedex" ></i>                    
                        <i class="fa fa-check" :class="!editingFormasEnvio ? 'text-secondary' :'text-success'" for="sedex" v-else></i>                    
                    </div>
                    <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formasenvio/sedex.png" class="formasenvio"> Sedex
                </label>
            </div>

            <div class="col-md-12 mb-2">
                <label class="lbl-edit d-flex align-items-center" style="gap:10px">                    
                    <input 
                        type="checkbox" 
                        v-model="parametros.rodape.formasenvio.jadlog" 
                        :disabled="!editingFormasEnvio"
                        id="jadlog"
                        name="jadlog"
                        v-show="false"
                    >
                    <div>
                        <i class="fa fa-times" :class="!editingFormasEnvio ? 'text-secondary' :'text-danger'" for="jadlog" v-if="!parametros.rodape.formasenvio.jadlog" ></i>                    
                        <i class="fa fa-check" :class="!editingFormasEnvio ? 'text-secondary' :'text-success'" for="jadlog" v-else></i>                    
                    </div>
                    <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formasenvio/jadlog.png" class="formasenvio"> JadLog
                </label>
            </div>

            <div class="col-md-12 mb-2">
                <label class="lbl-edit d-flex align-items-center" style="gap:10px">                    
                    <input 
                        type="checkbox" 
                        v-model="parametros.rodape.formasenvio.latam" 
                        :disabled="!editingFormasEnvio"
                        id="latam"
                        name="latam"
                        v-show="false"
                    >
                    <div>
                        <i class="fa fa-times" :class="!editingFormasEnvio ? 'text-secondary' :'text-danger'" for="latam" v-if="!parametros.rodape.formasenvio.latam" ></i>                    
                        <i class="fa fa-check" :class="!editingFormasEnvio ? 'text-secondary' :'text-success'" for="latam" v-else></i>                    
                    </div>
                    <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formasenvio/latam.png" class="formasenvio"> Latam Cargo
                </label>
            </div>

            <div class="col-md-12 mb-2">
                <label class="lbl-edit d-flex align-items-center" style="gap:10px">                    
                    <input 
                        type="checkbox" 
                        v-model="parametros.rodape.formasenvio.azul_express" 
                        :disabled="!editingFormasEnvio"
                        v-show="false"
                        id="azul_express"
                        name="azul_express"
                    >
                    <div>
                        <i class="fa fa-times" :class="!editingFormasEnvio ? 'text-secondary' :'text-danger'" for="azul_express" v-if="!parametros.rodape.formasenvio.azul_express" ></i>                    
                        <i class="fa fa-check" :class="!editingFormasEnvio ? 'text-secondary' :'text-success'" for="azul_express" v-else></i>                    
                    </div>
                    <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formasenvio/azul_express.png" class="formasenvio"> Azul Cargo Express
                </label>
            </div>


            <div class="col-md-12 mt-3" v-if="editingFormasEnvio">
                <v-button label="Salvar" :success="true" @click="handleSalvarFormasEnvio"></v-button>
                <v-button label="Cancelar" @click="handleCancelarFormasEnvio"></v-button>
            </div>
            <div class="col-md-12 mt-3" v-if="parametros.rodape.habilitaFormasEnvio && !editingFormasEnvio">
                <v-button label="Desativar" :danger="true" @click="handleDesativar('formasenvio')"></v-button>
                <v-button icon="fa-pencil" label="Editar" @click="handleEditFormasEnvio"></v-button>
            </div>
        </div>
    </div>
    <hr>
  </div>

</template>

<style scoped>
.container-accordion{
    transition: all .4s ease-in-out;
    overflow-x: hidden;
}
.container-open{
    overflow-y: hidden;
    max-height: 900px;
}

.container-close{
    overflow-y: hidden;
    max-height: 120px;
}
.formasenvio{
    height: 30px;
    width: 50px;
}


</style>



// WEBPACK FOOTER //
// src/forms-loja/config-selformasenvio-form-loja.vue